import { Helmet } from 'react-helmet';
import ReportstaffrevenueDetail
  from 'src/components/reportstaffrevenue-detail/ReportstaffrevenueDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import ReportstaffrevenueListToolbar from '../components/reportstaffrevenue-detail/ReportstaffrevenueListToolbar';

const ReportstaffrevenueList = () => (
  <>
    <Helmet>
      <title>Báo cáo doanh thu theo nhân viên</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <ReportstaffrevenueListToolbar />
        <Box sx={{ pt: 3 }}>
          <ReportstaffrevenueDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default ReportstaffrevenueList;
